import { FaHeadSideVirus } from "react-icons/fa";
import { MdEngineering, MdImportantDevices } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <MdEngineering />,
    title: "Software Engineer",
    des: "A software engineer designs, develops, and maintains software applications to meet specific needs using different technology tools.",
  },
  {
    id: 2,
    icon: <MdImportantDevices />,
    title: "Full Stack Developer",
    des: "A full stack developer handles both front-end and back-end aspects of web development, from user interfaces to server-side functionalities.",
  },
  {
    id: 3,
    icon: <FaHeadSideVirus />,
    title: "CP trainer",
    des: "A competitive programming trainer teaches problem-solving skills and coding strategies to help individuals excel in coding competitions.",
  },
];
